module.exports = "/_next/static/images/dreamland-testimonial-7ac919e74e6251a35fd4b53bd5021e43.jpg";